<div *ngIf="tipooauth==3">
<p>
de la url similara a <b>https://ipsofacto.com/http:////localhost:20000/iboauth?oauth_token=bc39514087e1eacc1ccd&oauth_verifier=d69f854ca40268c42ade</b>
</p>
<p>Copia el valor de oauth_verifier
    El valor debe ser similar a <b>d69f854ca40268c42ade</b>
</p>

<div class="row mt-4" *ngIf="oauthVerifier == ''"><input type="text"
placeholder="d69f854ca40268c42ade"
matInput
[formControl]="myControl"  [(ngModel)]="oauthVerifierTxt" >
    <button  mat-flat-button class="ccorbit d-block fw-semibold mt-4" (click)="setVerifier();">
        Generar Live Session
    </button>
</div>
</div>

<div *ngIf="tipooauth==1">
<p>Copia los Token de acceso y Secreto de token de acceso generados en la pagina de autoservicio</p>
    <p></p>  
    <div class="row mt-4" *ngIf="oauthVerifier == ''">
        <input type="text"
        placeholder="Token de acceso"
        matInput
        [formControl]="myControl"  [(ngModel)]="accessToken" >
        <input type="text"
        placeholder="Secreto de token de acceso"
        matInput
        [formControl]="myControl"  [(ngModel)]="tokenSecret" >
        <button  mat-flat-button class="ccorbit d-block fw-semibold mt-4" (click)="getlivesesssiontoken();">
                Generar Live Session
            </button>
        </div>  
</div>